import { Routes } from '@angular/router';
import { RegistrationPageComponent } from './pages/registration-page/page/registration-page.component';
import { ThankYouPageComponent } from './pages/thank-you-page/thank-you-page.component';
import { ThankYouGuard } from './core/guards/thankYou.guard';
import { MaintenanceModeGuard } from './core/guards/maintenanceModeGuard';
import { MaintenanceModePageComponent } from './pages/maintenance-mode-page/maintenance-mode-page.component';
import { TokenGuard } from './core/guards/token.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [TokenGuard, MaintenanceModeGuard, ThankYouGuard],
    component: RegistrationPageComponent,
    data: { headerText: 'CARRIERDB.SUPPLIER_REGISTRATION' },
  },
  {
    path: 'thankYou',
    canActivate: [TokenGuard, MaintenanceModeGuard, ThankYouGuard],
    component: ThankYouPageComponent,
    data: { headerText: 'GENERAL.WELCOME' },
  },
  {
    path: 'maintenanceMode',
    canActivate: [TokenGuard, MaintenanceModeGuard],
    component: MaintenanceModePageComponent,
    data: { headerText: 'GENERAL.MAINTENANCE_MODE' },
  },
  {
    path: '**',
    canActivate: [TokenGuard, MaintenanceModeGuard, ThankYouGuard],
    component: RegistrationPageComponent,
    data: { headerText: 'CARRIERDB.SUPPLIER_REGISTRATION' },
  },
];
